import React, { useEffect, useState } from "react";
import "./FooterRefresh.css";

const Footer = () => {
  const [footerSocial, setFooterSocial] = useState([]);
  const [footerCopyright, setFooterCopyright] = useState([]);
  const [logo, setLogo] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false); // State for "Scroll to Top" button visibility

  // Fetch logo data
  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/logo`)
      .then((res) => res.json())
      .then((info) => setLogo(info));
  }, []);

  // Fetch social links
  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  // Fetch copyright
  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/copyrights`)
      .then((res) => res.json())
      .then((info) => setFooterCopyright(info));
  }, []);

  // Handle form submission for subscribers
  const handleSubscriber = (event) => {
    event.preventDefault();
    const subemail = event.target.subemail.value;

    const addItem = { subemail };

    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/add-subscriber`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addItem),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Subscription request sent successfully!");

        // Trigger GTM, GA4 and Meta Pixel tracking events for the subscription conversion
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'newsletter_signup',
            email: subemail
          });

          if (typeof window.gtag === 'function') {
            window.gtag('event', 'sign_up', {
              event_category: 'engagement',
              event_label: 'Newsletter Subscriber'
            });
          }

          if (typeof window.fbq === 'function') {
            window.fbq('track', 'CompleteRegistration');
          }
        } catch (analyticsError) {
          console.error('Analytics tracking failed:', analyticsError);
        }
      });
  };

  // Show "Scroll to Top" button when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div>
        {footerSocial.map((s) => (
          <footer className="main-footer" key={s.id}>
            <div className="auto-container">
              <div className="widget-section">
                <div className="row clearfix">
                  {/* Logo Widget */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget logo-widget">
                      {logo.map((l) => (
                        <figure className="footer-logo" key={l.id}>
                          <a href="/">
                            <img src={l.logo} alt="Logo" />
                          </a>
                        </figure>
                      ))}
                      <p>{s.aboutText}</p>
                      <ul className="social-links clearfix">
                        <li>
                          <a
                            href={s.fblink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-facebook" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={s.inslink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-instagram" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={s.youlink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Quick Links */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget links-widget ml_60">
                      <div className="widget-title">
                        <h3>Quick Links</h3>
                      </div>
                      <div className="widget-content">
                        <ul className="links-list clearfix">
                          <li>
                            <a href="/">Home</a>
                          </li>
                          <li>
                            <a href="#about-sec">About</a>
                          </li>
                          <li>
                            <a href="#services-sec">Services</a>
                          </li>
                          <li>
                            <a href="/pricing">Pricing</a>
                          </li>
                          <li>
                            <a href="/support">Support</a>
                          </li>
                          <li>
                            <a href="/contact-us">Contact</a>
                          </li>
                          <li>
                            <a href="/privacy-policy">Privacy Policy</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Subscribe Newsletter */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget subscribe-widget">
                      <div className="widget-title">
                        <h3>Subscribe Newsletter</h3>
                      </div>
                      <div className="widget-content">
                        <p>Thank you for subscribing to our newsletter!</p>
                        <div className="form-inner">
                          <form onSubmit={handleSubscriber} method="post">
                            <div className="form-group">
                              <input
                                type="email"
                                name="subemail"
                                placeholder="Email Address"
                                required
                              />
                              <button type="submit" className="theme-btn btn-one">
                                Subscribe
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom centred">
              <div className="auto-container">
                {footerCopyright.map((c) => (
                  <div className="copyright" key={c.id}>
                    <p>{c.copyrightText}</p>
                  </div>
                ))}
              </div>
            </div>
          </footer>
        ))}

        {/* Scroll to Top Button */}
        {isScrollVisible && (
          <div className="modern-scroll-to-top">
            <button
              type="button"
              className="modern-scroll-top-button"
              onClick={scrollToTop}
              aria-label="Go to top"
            >
              <span className="modern-scroll-top-icon">↑</span>
              <span className="modern-scroll-top-text">Top</span>
            </button>
          </div>
        )}
        
      </div>
    </>
  );
};

export default Footer;
